export const instagramData = [
  {
    name: "CNN To Permanently Close Its Doors As Ratings Plunge 30 Percent",
    number_of_posts: 560,
    percentage_fake: 86.6,
    spreaders: "COM 1",
    victims: "COM 4",
    ideology: "Progressive Left",
  },
  {
    name: "Eric Trump: It would be 'foolish' for my dad to release tax returns",
    number_of_posts: 194,
    percentage_fake: 82.3,
    spreaders: "COM 3",
    victims: "COM 5",
    ideology: "Progressive Left",
  },
  {
    name: "BREAKING! Roy Mooreâ€™s Accuser Worked for Democratic Leaders and Is Actively Campaigning for Mooreâ€™s Opponent â‹† Activist Mommy",
    number_of_posts: 486,
    percentage_fake: 79.3,
    spreaders: "COM 4",
    victims: "COM 1",
    ideology: "Progressive Left",
  },
  {
    name: "Kurt Russel Just SHOWED Overpaid Celebs Itâ€™s Time To Shut Up About Trump â€“ Hits Them Where It Hurts!",
    number_of_posts: 280,
    percentage_fake: 56,
    spreaders: "COM 1",
    victims: "COM 5",
    ideology: "Progressive Left",
  },
  {
    name: "BREAKING: 60 People Just Found Dead In Ohio",
    number_of_posts: 150,
    percentage_fake: 55.5,
    spreaders: "COM 8",
    victims: "COM 6",
    ideology: "Conservative",
  },
  {
    name: "Denzel Washington: With Trump we avoided war with Russia and Orwellian Police State",
    number_of_posts: 473,
    percentage_fake: 49,
    spreaders: "COM 11",
    victims: "COM 6",
    ideology: "Conservative",
  },
  {
    name: "Oprah Winfrey: The Butler, racism and Obama",
    number_of_posts: 45,
    percentage_fake: 43.2,
    spreaders: "COM 14",
    victims: "COM 3",
    ideology: "Progressive Left",
  },
  {
    name: "USA: Mysterious Nazi submarine from WWII discovered in Great Lakes!",
    number_of_posts: 320,
    percentage_fake: 10,
    spreaders: "COM 16",
    victims: "COM 7",
    ideology: "Progressive Left",
  },
  {
    name: "Computer Models Show IRMA Destroying New York City On Sept. 10",
    number_of_posts: 180,
    percentage_fake: 8,
    spreaders: "COM 18",
    victims: "COM 8",
    ideology: "Progressive Left",
  }
];
